import clsx from 'clsx';
import React from 'react';

const Select = ({ children, className, onBlur, ...props }) => {
  return (
    <select
      onBlur={onBlur}
      className={clsx(`appearance-none block w-full text-left`, className)}
      {...props}
    >
      {children}
    </select>
  );
};

export default Select;
